import * as THREE from 'three'

export default function createWall({ scene })
{
  const wall = new THREE.Mesh(
    new THREE.PlaneGeometry(15, 15, 15),
    new THREE.MeshStandardMaterial()
  )

  wall.receiveShadow = true
  wall.rotation.y = Math.PI
  wall.position.y = -3
  wall.position.z = 5

  scene.add(wall)

  return wall
}
